import './lib/polyfills/IE11';
import './styles/utlilities/_index.scss';
import { checkBrowserFeatures, shouldLog } from './lib/helpers';

if (shouldLog) require('logrocket').init('daupnu/mgmw');

if (checkBrowserFeatures()) import('./MGMW').catch(err => console.error(err));
else import('./UnsupportedBrowser').catch(err => console.error(err));

// MutationObserver + computed style workaround to remove unwanted fullscreen iframes injected by extensions or third-party scripts.
// This will not affect app-owned iframes unless they match the same criteria (fullscreen, fixed/absolute, direct child of body).
function removeUnwantedIframes() {
  document.querySelectorAll('iframe').forEach(iframe => {
    const computed = window.getComputedStyle(iframe);
    const rect = iframe.getBoundingClientRect();

    if (
      iframe.parentElement === document.body &&
      (computed.position === 'fixed' || computed.position === 'absolute') &&
      computed.width === `${rect.width}px` &&
      computed.height === `${rect.height}px`
    ) {
      iframe.remove();
    }
  });
}

window.addEventListener('DOMContentLoaded', () => {
  removeUnwantedIframes();

  // Observe for new iframes added after page load
  const observer = new MutationObserver(() => {
    removeUnwantedIframes();
  });
  observer.observe(document.body, { childList: true, subtree: true });
});
